import * as React from "react";
import { MovieItemViewSkeleton } from "./movie/MovieItemViewSkeleton";
import "./movie/movieItemViewSkeletonStyles.css";
import { FilterSkeletons } from "./filter/FilterSkeletons";
export var SkeletonContentLayout = function (_a) {
    var _b = _a.showTitle, showTitle = _b === void 0 ? true : _b, _c = _a.skeletonCount, skeletonCount = _c === void 0 ? 6 : _c, _d = _a.isBlockMoviesScreen, isBlockMoviesScreen = _d === void 0 ? false : _d, _e = _a.isMoviesScreen, isMoviesScreen = _e === void 0 ? false : _e;
    return (React.createElement("div", { className: "skeleton-container " + (isBlockMoviesScreen && "block-movies-skeleton") },
        isMoviesScreen && React.createElement(FilterSkeletons, null),
        showTitle && React.createElement("h2", { className: "skeleton-header" }),
        Array.from({ length: skeletonCount }).map(function (_, index) { return (React.createElement(MovieItemViewSkeleton, { key: index })); })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/SkeletonContentLayout.tsx
// module id = 29
// module chunks = 1